import { useEffect, useMemo } from "react";
import { useGetInitialAuthMutation } from "./authApi";

const useStaging = process.env.REACT_APP_MOLO_DEV === "staging";

const useAuth = () => {
  const [
    getInitialAuth,
    {
      isError: isAuthError,
      isSuccess: isAuthSuccess,
      isUninitialized: isAuthUninitialized,
    },
  ] = useGetInitialAuthMutation();

  useEffect(() => {
    if (isAuthUninitialized) {
      getInitialAuth();
    }
  }, [getInitialAuth, isAuthUninitialized]);

  useEffect(() => {
    if (!isAuthUninitialized && isAuthError) {
      const redirect = encodeURIComponent(window.location.href);
      window.location.href = `/Login?r=${redirect}`;
    }
  }, [isAuthError, isAuthUninitialized]);

  return useMemo(() => isAuthSuccess, [isAuthSuccess]);
};

export default useStaging ? () => true : useAuth;
